<template>
    <v-card :variant="variant" :elevation="elevation" rounded="0">
        <v-card-title class="text-h6">
            {{ $t('carsRent.pick-up_and_drop-off_points') }}
        </v-card-title>
        <v-card-text>
            <v-form ref="form" v-model="valid">
                <v-row>
                    <v-col v-if="pickUpItems.length" cols="12" md="3">
                        <v-select
                            :items="pickUpItems"
                            :label="$t('carsRent.pick-up_point')"
                            :rules="[
                                v =>
                                    disableRequiredRule ||
                                    !!v ||
                                    `${$t('carsRent.pick-up_point')} ${$t('validation.required')}`,
                            ]"
                            :disabled="disabled"
                            @update:model-value="setPickUpLocation"
                        />
                        <div v-if="pickUpLocation.address">
                            <v-icon color="primary" start size="small">mdi-map-marker</v-icon>
                            {{ pickUpLocation.address }}
                            <div
                                v-if="pickUpLocation.latitude && pickUpLocation.longitude"
                                class="ms-2 d-inline-block text-caption text-primary text-decoration-underline text-lowercase cursor-pointer"
                                @click="
                                    $emit('show-on-map', {
                                        latitude: pickUpLocation.latitude,
                                        longitude: pickUpLocation.longitude,
                                    })
                                "
                            >
                                {{ $t('show_on_map') }}
                            </div>
                        </div>
                    </v-col>
                    <v-col v-if="dropOffItems.length" cols="12" md="3">
                        <v-select
                            :items="dropOffItems"
                            :label="$t('carsRent.drop-off_point')"
                            :rules="[
                                v =>
                                    disableRequiredRule ||
                                    !!v ||
                                    supplierCode === 'jonview' ||
                                    `${$t('carsRent.drop-off_point')} ${$t('validation.required')}`,
                            ]"
                            :disabled="disabled"
                            @update:model-value="setDropOffLocation"
                        />
                        <div v-if="dropOffLocation.address">
                            <v-icon color="primary" start size="small">mdi-map-marker</v-icon>
                            {{ dropOffLocation.address }}
                            <div
                                v-if="dropOffLocation.latitude && dropOffLocation.longitude"
                                class="ms-2 d-inline-block text-caption text-primary text-decoration-underline text-lowercase cursor-pointer"
                                @click="
                                    $emit('show-on-map', {
                                        latitude: dropOffLocation.latitude,
                                        longitude: dropOffLocation.longitude,
                                    })
                                "
                            >
                                {{ $t('show_on_map') }}
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class CarDetailsForm extends Vue {
        @VModel({default: false}) valid
        @Prop({required: true}) offer
        @Prop() product
        @Prop({default: false, type: Boolean}) disabled
        @Prop({default: 'text', type: String}) variant
        @Prop({default: 0}) elevation
        @Prop({default: false, type: Boolean}) disableRequiredRule

        beforeUnmount() {
            this.clearLocations()
        }

        setPickUpLocation(val) {
            carsRentStore.SET_PICK_UP_LOCATION(val)
        }

        setDropOffLocation(val) {
            carsRentStore.SET_DROP_OFF_LOCATION(val)
        }

        clearLocations() {
            carsRentStore.SET_PICK_UP_LOCATION({})
            carsRentStore.SET_DROP_OFF_LOCATION({})
        }

        get pickUpLocation() {
            return carsRentStore.pickUpLocation
        }

        get dropOffLocation() {
            return carsRentStore.dropOffLocation
        }

        get pickUpItems() {
            return (
                this.offer?.pickUpPoints?.map(value => ({
                    title: value.name || value.address || value.locationCode,
                    value,
                })) || []
            )
        }

        get dropOffItems() {
            return (
                this.offer?.returnPoints?.map(value => ({
                    title: value.name || value.address || value.locationCode,
                    value,
                })) || []
            )
        }

        get supplierCode() {
            return this.product?.info.supplierCode
        }
    }

    export default CarDetailsForm
</script>
